<template>
  <div id="app">
    <b-navbar :style="{ backgroundColor: '#f5f5f5' }" class="mb-4">
      <b-navbar-brand>
        <b-row>
          <b-col
            cols="12"
            md="6"
            :style="{ 'padding-right': '2rem !important' }"
          >
            <h4 class="text-dark">
              IEU <span class="font-weight-light">PROGRAM BULUCU</span>
            </h4>
          </b-col>
          <b-col cols="12" md="6">
            <h4 class="text-dark">
              <span
                class="font-weight-light"
                :style="{ backgroundColor: '#4caf50' }"
              >
                (2025-2026 GÜZ)
              </span>
            </h4>
          </b-col>
        </b-row>
      </b-navbar-brand>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-link href="https://www.instagram.com/ercanacar1"
          ><b-iconstack font-scale="3" animation="spin">
            <b-icon
              stacked
              icon="instagram"
              variant="danger"
              scale="0.75"
              shift-v="-0.25"
            ></b-icon></b-iconstack
        ></b-link>
      </b-navbar-nav>
    </b-navbar>

    <ScheduleFinder />
  </div>
</template>

<script>
import ScheduleFinder from "./components/ScheduleFinder.vue";

export default {
  name: "App",
  components: {
    ScheduleFinder,
  },
};
</script>

<style>
</style>
